import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/vue_string_filter'
import './plugins/smoot_picker'
import './plugins/vue_googlemaps'
import './plugins/vue_moment'
import './plugins/vue_tel_input'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/stylesheets/global_custom_style.scss'
import 'babel-polyfill'
import { ApolloProvider } from './apollo-provider'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.NODE_ENV === "production"){
  Sentry.init({
    dsn: 'https://16a78782b18c04da603cb06f919ceb98@o4507220973125632.ingest.de.sentry.io/4507298967912528',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: process.env.VUE_APP_VERSION,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.01,
    profileSampleRate: 0.1
  });

}

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    setGlobalCurrentLanguage: function (new_lang) {
      this.$vuetify.lang.current = new_lang;
      this.$moment.locale(new_lang);
    }
  },
})

new Vue({
  router,
  store,
  apolloProvider: ApolloProvider,
  render: h => h(App)
}).$mount('#app')


